import { render, staticRenderFns } from "./OtherNegativeRoom.vue?vue&type=template&id=26f581b8&"
import script from "./OtherNegativeRoom.vue?vue&type=script&lang=js&"
export * from "./OtherNegativeRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports